import { AuthService } from '../../../auth/auth-service.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { LayoutService } from '../../../@core/utils';
import { map, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserProfileComponent } from '../../../user/user-profile/user-profile.component';
import { environment } from '../../../../environments/environment';
import { UserLogoComponent } from '../../../user/user-logo/user-logo.component';
import { UserLanguageComponent } from '../../../user/user-language/user-language.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { confirm, alert, custom } from 'devextreme/ui/dialog';
import { MfaService } from '../../../auth/mfa-service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild(UserProfileComponent) userProfileDialog: UserProfileComponent;
  @ViewChild(UserLogoComponent) userLogoDialog: UserLogoComponent;
  @ViewChild(UserLanguageComponent) userLanguageComponent: UserLanguageComponent;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  allowUploadKlantLogo: boolean = false;
  user: any;
  environmentName: string;
  userMenu = [];
  PresenterModusEnabled: boolean = false;

  currentTheme = 'default';
  mfaResetPopupVisible = false;
  mfaResetPassword = '';
  mfaResetErrorMessage = '';
  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private authService: AuthService,
    private _translateService: TranslateService,
    private _mfaService: MfaService) {
    this.allowUploadKlantLogo = authService.userHasClaim('KlantLogoCreate');
    this.PresenterModusEnabled = authService.userHasRole(['DashboardPresenter']);

  }
  ngOnInit() {
    this.environmentName = environment.environmentName;
    this.currentTheme = this.themeService.currentTheme;
    this.user = { name: this.authService.getUserName() };

    this.createMenu();

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'user-context-menu'),
        map(({ item: { data } }) => data.actionId),
      )
      .subscribe(async item => {
        if (item === 'password') {
          this.userProfileDialog.show();
        } else if (item === 'logo') {
          this.userLogoDialog.show();
        } else if (item === 'language') {
          this.userLanguageComponent.show();
        } else if (item === 'mfa-reset') {
          this.mfaResetPassword = '';
          this.mfaResetErrorMessage = '';
          this.mfaResetPopupVisible = true;
        }
      });

    this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.createMenu();
    });
  }

  createMenu(): void {
    if (this.allowUploadKlantLogo) {
      this.userMenu = [
        { data: { actionId: 'logo' }, title: this._translateService.instant('GEBRUIKERMENU.LOGO_UPLOADEN') },
        //todo: weer inschakelen bij meerdere talen { data: { actionId: 'language' }, title: this._translateService.instant('GEBRUIKERMENU.TAAL_WIJZIGEN') },
        { data: { actionId: 'mfa-reset' }, title: this._translateService.instant('GEBRUIKERMENU.MFA_RESET') },
        { data: { actionId: 'password' }, title: this._translateService.instant('GEBRUIKERMENU.WACHTWOORD_WIJZIGEN') },
        { title: this._translateService.instant('GEBRUIKERMENU.UITLOGGEN'), url: '/auth/logout' },
      ];
    } else {
      this.userMenu = [
        //todo: weer inschakelen bij meerdere talen { data: { actionId: 'language' }, title: this._translateService.instant('GEBRUIKERMENU.TAAL_WIJZIGEN') },
        { data: { actionId: 'mfa-reset' }, title: this._translateService.instant('GEBRUIKERMENU.MFA_RESET') },
        { data: { actionId: 'password' }, title: this._translateService.instant('GEBRUIKERMENU.WACHTWOORD_WIJZIGEN') },
        { title: this._translateService.instant('GEBRUIKERMENU.UITLOGGEN'), url: '/auth/logout' },
      ];
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  onMfaResetConfirm() {
    if (!this.mfaResetPassword || this.mfaResetPassword.trim() === '') {
      alert('Voer a.u.b. uw wachtwoord in.', 'Wachtwoord vereist');
      return;
    }
    this.mfaResetErrorMessage = '';
    this._mfaService.ResetUserMfaWithPassword(this.authService.getUserId(), this.mfaResetPassword).subscribe({
      next: () => {
        alert(this._translateService.instant('GEBRUIKERMENU.MFA_RESET_GELUKT'), this._translateService.instant('ALGEMEEN.GELUKT'));
        this.mfaResetPopupVisible = false;
      },
      error: (err) => {
        const errorMsg = err.error || this._translateService.instant('GEBRUIKERMENU.MFA_RESET_MISLUKT');
        this.mfaResetErrorMessage = `Het is niet mogelijk om het MFA opnieuw in te stellen: ${errorMsg}`;
      }
    });
  }

  onMfaResetCancel() {
    this.mfaResetPopupVisible = false;
    this.mfaResetPassword = '';
    this.mfaResetErrorMessage = '';
  }
}
